// Dynamic field types for payment method forms (sent/received as JSON)
export const PAYMENT_FIELD_TYPES = [
  { value: "text", label: "Text" },
  { value: "email", label: "Email" },
  { value: "number", label: "Number" },
  { value: "select", label: "Dropdown" },
  { value: "checkbox", label: "Checkbox" },
  { value: "image", label: "Image / QR Upload" },
] as const;

export type PaymentFieldType = (typeof PAYMENT_FIELD_TYPES)[number]["value"];

export interface PaymentMethodField {
  key: string;
  label: string;
  type: PaymentFieldType;
  required: boolean;
  options?: string[]; // for select type
}

export interface PaymentMethodFormPayload {
  name: string;
  json_text: PaymentMethodField[];
}

export interface PaymentMethodRecord {
  id: number | string;
  name: string;
  json_text: PaymentMethodField[];
  influencerPaymentMethodsCount?: number | string;
  created_at?: string;
  updated_at?: string;
}

// Country with assigned payment methods
export interface CountryPaymentAssignment {
  payment_method_id: number | string;
  is_active: boolean;
  payment_method?: PaymentMethodRecord;
}

export interface CountryWithPaymentMethods {
  id: number | string;
  country_name: string;
  countryPaymentMethods?: CountryPaymentAssignment[];
}

export interface CountryPaymentPayload {
  country_id: number | string;
  payment_method_ids: number | string[];
}
